export default "__VITE_ASSET__1ad1c0ca__"